/**
 * Default horizontal + vertical inset for main app content (org console tabs, PageContainer, etc.).
 */
/* Even top and bottom: a taller bottom inset made pages that almost fit scroll for nothing. */
export const APP_MAIN_SECTION_PADDING = "px-4 py-5 sm:px-6 sm:py-6 md:px-8";

/** MAPS cohort tab — vertical inset only; horizontal space comes from PageContainer so the grid uses full content width. */
export const MAPS_TAB_SECTION_PADDING = "px-0 pb-4 pt-3 sm:pb-5 sm:pt-4";
